'use strict';

var GridRemoveFilteringButtonDirective = function GridRemoveFilteringButtonDirective() {
  return {
    restrict: 'E',
    require: '^^rmGridToolbar',
    scope: true,
    template: require('../templates/grid-remove-filtering-button.html'),
    controller: 'GridRemoveFilteringButtonController'
  };
};
GridRemoveFilteringButtonDirective.$inject = [];
module.exports = GridRemoveFilteringButtonDirective;